<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-card class="elevation-6">
            <v-card-text>
                <v-toolbar color="white" flat>
                    <v-toolbar-title v-if="!newBook">
                        Πεδίο Επεξεργασίας
                        <!--<v-icon v-if="finalizedByPublisher" color="green" class="mr-3">info</v-icon>-->
                        <!--<v-tooltip left >-->
                        <!--<template v-slot:activator="{ on, attrs }">-->
                        <!--<v-icon color="red" class="mr-3" v-on="on">info</v-icon>-->
                        <!--</template>-->
                        <!--<span>Δεν έχει ολοκληρωθεί η εγγραφή του συγγράμματος βάσει Κ.Υ.Α. 125766/Ζ1 05.08.2016. <br>-->
                        <!--Συμπληρώστε όλα τα υποχρεωτικά πεδία και τα αρχεία του συγγράμματος και <br> πατήστε "Αποθήκευση" για να γίνει ολοκληρωμένη η εγγραφή και <br>-->
                        <!--να είναι δυνατή η επιλογή-->
                        <!--του συγγράμματος από Γραμματείες.</span>-->
                        <!--</v-tooltip>-->
                    </v-toolbar-title>

                    <v-toolbar-title v-else>
                        Προσθήκη Νέου Συγγράμματος
                    </v-toolbar-title>

                </v-toolbar>

                <v-divider></v-divider>
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col>
                            <v-text-field
                                    :disabled="disableAllFields"
                                    :rules="isRequired "
                                    dense
                                    label="Τίτλος"
                                    outlined
                                    v-model="title"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                    :disabled="disableAllFields"
                                    dense
                                    label="Υπότιτλος"
                                    outlined
                                    required
                                    v-model="subtitle"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row align="center">
                        <v-col class="py-0">
                            <v-text-field
                                    :disabled="disableAllFields"
                                    :rules="isRequired "
                                    dense
                                    label="Συγγραφείς"
                                    outlined
                                    v-model="authors"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-text-field
                                    :disabled="disableAllFields"
                                    :rules="Number(publicationYear) <= getYear() ? yearNumberValidation : yearValidation"
                                    dense
                                    label="Έτος Τρέχουσας Έκδοσης"
                                    outlined
                                    required
                                    v-model="publicationYear"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                    :disabled="disableAllFields"
                                    dense
                                    label="Αριθμός Έκδοσης"
                                    outlined
                                    required
                                    v-model="editionNumber"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-text-field
                                    :disabled="disableAllFields"
                                    dense
                                    :rules="urlValidation"
                                    label="Ιστοσελίδα Συγγράμματος"
                                    outlined
                                    required
                                    v-model="linkToPublisher"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-btn  @click="openLicenseModal"
                                    min-height="40"
                                   block
                                    :disabled="disableAllFields"
                                    style="text-transform: none !important;"
                                    outlined
                                    :color="licenseId != '' && licenseId != null ? 'primary' : 'red'"
                            >{{licenseId != '' && licenseId != null ? licenseId : 'Άδεια χρήσης'}}</v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-btn @click="dialog = true"
                                    :disabled="disableAllFields"
                                    block
                                    color="primary"
                                    outlined
                                    style="text-transform: none !important;"
                                    text>Λέξεις Κλειδιά
                            </v-btn>
                        </v-col>
                        <v-col>
                            <v-btn  @click="openBookAllocatorFilesModal"
                                    :disabled="disableAllFields"
                                    block
                                    :color="$store.getters.editPublisherBook.pathToFile ? 'primary' : 'red'"
                                    outlined
                                    style="text-transform: none !important;" text>Αρχεία Βιβλίου
                            </v-btn>
                        </v-col>

                    </v-row>

                    <v-row>
                        <v-col>
                            <v-btn :disabled="disableAllFields ? true : valid  && licenseId != '' && licenseId && $store.getters.editPublisherBook.pathToFile? false : true" @click="save" block color="primary">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-dialog
                max-width="500"
                v-model="dialog">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Λέξεις κλειδιά
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="9">
                            <v-text-field
                                    label="Λέξεις κλειδιά"
                                    outlined
                                    v-model="keyWordsFied"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-btn @click="saveKeyWord()" color="primary" fab>
                                <v-icon class="text--white">save</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-data-table
                            :headers="headers"
                            :items="keywords"
                            class="elevation-6"
                            no-data-text="Δεν υπάρχουν δεδομένα."
                    >
                        <template v-slot:item="{ item }">

                            <tr>
                                <td class="text-xs-right">{{ item }}</td>
                                <td class="text-xs-right">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-on="on" @click="deleteKeyWord(item)" color="red">delete</v-icon>
                                        </template>
                                        <span>Διαγραφή</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="dialog = false"
                            color="primary"
                            text>
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <LicenseModal :licenseId="licenseId"/>

        <BookAllocatorFiles :pathToCover="pathToCover" :pathToFile="pathToFile" :pathToTOC="pathToTOC" :bookId="bookId"/>

    </div>
</template>

<script>

    import {eventBus} from "../../../main";
    import LicenseModal from "./LicenseModal";
    import BookAllocatorFiles from "./BookAllocatorFiles";
    import utils from "../../../utilities"
    import request from "../../../requests"

    export default {
        name: "AllocatorBookEdit",
        components: {BookAllocatorFiles, LicenseModal},
        data: () => ({
            newBook: false,
            dialog: false,
            disableAllFields: true,
            fab: false,
            valid: false,
            pathToCover: '',
            pathToFile: '',
            pathToTOC: '',
            bookId: 0,
            title: '',
            subtitle: '',
            authors: '',
            publicationYear: '',
            editionNumber: null,
            linkToPublisher: '',
            licenseId: '',
            keyWordsFied: '',
            keywords: [],
            headers: [
                {
                    text: 'Λέξεις κλειδιά',
                    align: 'start',
                    sortable: false
                },
                { text: 'Action', value: 'calories', sortable: false },
            ],
            isRequired: [v => !!v || "Το πεδίο είναι Υποχρεωτικό"],
            urlValidation: [
                v => !!v || "Το πεδίο είναι Υποχρεωτικό",
                v => /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(v) || "Το πεδίο δεν είναι έγκυρο"
            ],
			yearValidation: [
				v => false || "Μικρότερο ή ίσο του επόμενου έτους",
			],
			yearNumberValidation: [
				v => !!v || "Το πεδίο είναι Υποχρεωτικό",
				v => /^(19|20)[0-9]{2}$/.test(v) || "Το Έτος δεν είναι Αποδεκτό"],

		}),

        methods: {

            //    create the edit Fields
            createEditAllocatorFields(show) {

                var data = this.$store.getters.editPublisherBook;

                this.title = data.title;
                this.subtitle = data.subtitle;
                this.authors = data.authors;
                this.publicationYear = data.publicationYear;
                this.editionNumber = data.editionNumber;
                this.linkToPublisher = data.linkToPublisher;
                this.licenseId = data.licenseId;
                this.keywords = data.keywords;
                this.pathToCover = data.pathToCover;
                this.pathToFile = data.pathToFile;
                this.pathToTOC = data.pathToTOC;
                this.bookId = data.id;

                if (show) {
                    this.disableAllFields = false;
                    this.newBook = false;
                } else {
                    if (!show && this.newBook) {
                        this.disableAllFields = false;
                    }
                    else {
                        this.disableAllFields = true;
                    }
                }
            },

            deleteAllocatorItem(){

                this.newBook = false;
                this.createEditAllocatorFields(true);
            },

            addNewAllocatorBook(){

                this.newBook = true;
                this.createEditAllocatorFields(false);
            },

			getYear(){
				var date = new Date();
				return date.getFullYear() + 1
			},

            save() {

                var book = this.createBookObject();
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.editBook(token, book, this.editBookCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }

            },

            editBookCallBack(response) {

                this.$store.commit('setPublisherBooks', response);
                this.$store.commit('setLoadingModal', false);
            },

            //create the book Object to pass in request
            createBookObject() {

                var book = this.$store.getters.editPublisherBook;

                book.title = this.title;
                book.subtitle = this.subtitle;
                book.authors = this.authors;
                book.publicationYear = this.publicationYear;
                book.editionNumber = this.editionNumber;
                book.linkToPublisher = this.linkToPublisher;
                book.licenseId = this.licenseId;
                book.keywords = this.keywords;
                book.pathToCover = this.$store.getters.editPublisherBook.pathToCover;
                book.pathToFile = this.$store.getters.editPublisherBook.pathToFile;
                book.pathToTOC = this.$store.getters.editPublisherBook.pathToTOC;

                return book;
            },

            saveKeyWord() {
                if (this.keywords != undefined && this.keywords != null && this.keyWordsFied != '') {
                    for (var i = 0; i < this.keywords.length; i++) {
                        if (this.keywords[i] == this.keyWordsFied)
                            return
                    }
                    this.keywords.push(this.keyWordsFied);
                    this.keyWordsFied = ''
                }
                else {
                    if (this.keyWordsFied != '') {
                        this.keywords = [];
                        this.keywords.push(this.keyWordsFied);
                        this.keyWordsFied = '';
                    }
                }
            },

            deleteKeyWord(word) {

                for (var i = 0; i < this.keywords.length; i++) {
                    if (this.keywords[i] == word) {
                        this.keywords.splice(i, 1);
                        return;
                    }
                }
            },

            openLicenseModal(){

                this.$store.commit('setLicenseModal', true);

            },

            openBookAllocatorFilesModal() {

                this.$store.commit('setBookAllocatorFileModal', true);
            },
            updateLicense(licenseId){
                this.licenseId = licenseId;
            },

        },

        created() {
            eventBus.$on('createEditAllocatorFields', (show) => {
                this.createEditAllocatorFields(show);
            });
            eventBus.$on('deleteAllocatorItem', () => {
                this.deleteAllocatorItem();
            });
            eventBus.$on('addNewAllocatorBook', () => {
                this.addNewAllocatorBook();
            });
            eventBus.$on('updateLicense', (licenseId) =>{
                this.updateLicense(licenseId);
            });
        }
    }
</script>

<style scoped>

</style>
